//****************************************
// Website scripts
//****************************************

// Event DOM ready
var callback = function(){
  // ================
  // Global data
  // ================
  const loadMoreBtn = document.querySelector('#load-more-posts');
  const darkSwitch = document.querySelector('#theme-dark');
  const lightSwitch = document.querySelector('#theme-light');
  const menuOpen = document.querySelector('#menu-open');
  const menuClose = document.querySelector('#menu-close');
  // const searchOpen = document.querySelector('#search-open');
  // const searchClose = document.querySelector('#search-close');
  // const searchForm = document.querySelector('#search-form');
  // const searchField = document.querySelector('#ghost-search-field');
  // const searchByTags = document.querySelectorAll('.js-search-tag');
  const msgBoxes = document.querySelectorAll('.js-msg-close');
  const images = document.querySelectorAll('.kg-image-card img, .kg-gallery-card img');
  const galleryImages = document.querySelectorAll('.kg-gallery-image img');
  const subscribeButton = document.querySelector('.subscribe-button');
  const socialShare = document.querySelectorAll('.js-share');
  const progressbar = document.querySelector('#progress');
  const postToc = document.querySelector('.post.has-toc');
  const scrollTop = document.querySelector('.scroll-to-top');
  const markedTitles = document.querySelectorAll(
    '.post-card__title, .post-hero__title, .sidebar__story-title, .archive-post__title, .page__title, .tag-header__title, .section__title, .search-result__title'
  );
  const spotlightTitles = document.querySelectorAll('.post-card--special .post-card__title');
  const spotlightTickers = document.querySelectorAll('.post-card--special .post-card__ticker');

  // =======
  // fitvids
  // =======
  fitvids();

  // =======================================
  // Title highlight markers
  // =======================================
  if (markedTitles.length > 0) {
    prepareTitleHighlights(markedTitles);
  }

  if (spotlightTickers.length > 0) {
    cleanSpotlightTickers(spotlightTickers);
  }

  // =======================================
  // Fit spotlight headlines to two lines
  // =======================================
  if (spotlightTitles.length > 0) {
    scheduleSpotlightTitleFit(spotlightTitles);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleSpotlightTitleFit(spotlightTitles));
    }

    window.addEventListener('resize', debounce(() => {
      scheduleSpotlightTitleFit(spotlightTitles);
    }, 150));

    window.addEventListener('pageshow', () => {
      scheduleSpotlightTitleFit(spotlightTitles);
    });
  }

  // ================
  // Lazy load images
  // ================
  lazyLoad = newLazyLoad();

  // ========================================
  // Modify header when scrolled
  // ========================================
  window.addEventListener('scroll', (event) => {
    // Modify header
    window.scrollY > 56 ? addClass('.header', 'is-scrolled') : '';
    window.scrollY <= 6 ? removeClass('.header', 'is-scrolled') : '';
    
    // Progressbar
    if (progressbar) {
      if (config.enable_progress_bar) {
        var scrollTop = document.querySelector('.post')["scrollTop"] ||
                        document.documentElement["scrollTop"] || 
                        document.body["scrollTop"];

        var scrollBottom = ( document.querySelector('.post')["scrollHeight"] ||
                            document.documentElement["scrollHeight"] ||
                            document.body["scrollHeight"]) - 
                            document.documentElement.clientHeight;

        scrollPercent = Math.round(scrollTop / scrollBottom * 100) + "%";
        document.getElementById("progress").style.setProperty("--scroll", scrollPercent);
      } else {
        progressbar.style.display = "none";
      }
    }

    if (config.enable_scroll_top) {
      // Scroll Top function
      window.scrollY > 200 ? addClass('.scroll-to-top', 'is-active') 
                           : removeClass('.scroll-to-top', 'is-active');
    }
    
  }, false);

  // =============
  // Scroll Top
  // =============
  if (scrollTop) {
    scrollTop.onclick = (evt) => {
      // window.scrollTo({top: 0, behavior: 'smooth'}); // not supported in all browsers
      scrollToTop();
    }
  }

  // =======================================
  // Key press event handling
  // =======================================
  window.onkeydown = (evt) => {
    const sourceClass = evt.srcElement.className;

    switch(evt.key) {
      case 'Escape':
        removeClass('.menu', 'is-active');
        // removeClass('.search', 'is-active');
        document.body.style.overflowY = "auto"; 
        break;
      default:
        break;// nothing to do
    }
  }

  // ============
  // Menu actions
  // ============
  if (menuOpen && menuClose) {
    menuOpen.onclick = () => {
      addClass('.menu', 'is-active');
    }
  
    menuOpen.onkeydown = (evt) => {
      if (evt.key === 'Enter' || evt.keyCode === '13') {
        addClass('.menu', 'is-active');
        menuClose.focus();
      }
    }

    menuClose.onclick = () => {
      removeClass('.menu', 'is-active');
    }
  
    menuClose.onkeydown = (evt) => {
      if (evt.key === 'Escape' || evt.keyCode === '27' || 
          evt.key === 'Enter' || evt.keyCode === '13') {
        removeClass('.menu', 'is-active');
        menuOpen.focus();
      }
    }
  }

  // ============
  // User Menu 
  // ============
  const userMenu = document.querySelector('.header__member--open');

  if (userMenu) {
    userMenu.onclick = () => {
      toggleClass('.header__member--open', 'is-active');
    }
  
    userMenu.onkeydown = (evt) => {
      if (evt.key === 'Enter' || evt.keyCode === '13') {
        toggleClass('.header__member--open', 'is-active');
        userMenu.focus();
      }
    }

    userMenu.blur = () => {
      removeClass('.header__member--open', 'is-active');
    }
  }

  // ============
  // Dropdown 
  // ============
  const dropdownBtn = document.querySelector('.js-dropdown-menu-toggle');
  let isDropdownFocus = false;
  if (dropdownBtn) {
    dropdownBtn.onfocus = (event) => {
      isDropdownFocus=true;
      event.currentTarget.nextElementSibling.classList.add('is-active');
    }

    dropdownBtn.onblur = (event) => {
      event.currentTarget.nextElementSibling.classList.remove('is-active');
    }

    dropdownBtn.onclick = (event) => {
      !isDropdownFocus ? event.currentTarget.nextElementSibling.classList.toggle('is-active')
                     : isDropdownFocus = false;
    }
  }
  
  // ==============
  // Search actions
  // ==============
  // if (searchOpen && searchClose) {
  //   searchOpen.onclick = () => {
  //     addClass('.search', 'is-active');
  //     document.body.style.overflowY = "hidden";
  //     searchField.focus();
  //   };
  
  //   searchOpen.onkeydown = (evt) => {
  //     if (evt.key === 'Enter' || evt.keyCode === '13') {
  //       addClass('.search', 'is-active');
  //       document.body.style.overflowY = "hidden";
  //       searchField.focus();
  //     }
  //   }

  //   searchClose.onclick = () => {
  //     removeClass('.search', 'is-active');
  //     document.body.style.overflowY = "auto";
  //   };
  
  //   searchClose.onkeydown = (evt) => {
  //     if (evt.key === 'Escape' || evt.keyCode === '27' || 
  //         evt.key === 'Enter' || evt.keyCode === '13') {
  //       removeClass('.search', 'is-active');
  //       document.body.style.overflowY = "auto";
  //       searchOpen.focus();
  //     }
  //   }
  // }

  // if ( searchField && searchForm ) {
  //   searchField.onfocus = () => {
  //     addClass('.search__form', 'focused');
  //   };
  
  //   searchForm.addEventListener('submit', (e) => {
  //       e.preventDefault();
  //   }, false);
  
  //   searchField.onblur = () => {
  //     removeClass('.search__form', 'focused');
  //   };
  // }

  // if ( searchByTags ) {
  //   searchByTags.forEach((el) => {
  //     el.onclick = (evt) => {
  //       searchField.value = evt.srcElement.innerText;
  //       searchField.dispatchEvent(new Event('keyup'));
  //     }

  //     el.onkeydown = (evt) => {
  //       if (evt.key === 'Enter' || evt.keyCode === '13') { 
  //         searchField.value = evt.srcElement.innerText;
  //         searchField.dispatchEvent(new Event('keyup'));
  //       }
  //     }
  //   });
  // }

  // =============
  // Theme actions
  // =============
  if (darkSwitch && lightSwitch) {
    darkSwitch.onclick = () => {
      setTheme('dark');
    }
  
    darkSwitch.onkeydown = (evt) => {
      if (evt.key === 'Enter' || evt.keyCode === '13') {
        setTheme('dark');
        lightSwitch.focus();
      }
    }
  
    lightSwitch.onclick = () => {
      setTheme('light');
    }
  
    lightSwitch.onkeydown = (evt) => {
      if (evt.key === 'Enter' || evt.keyCode === '13') {
        setTheme('light');
        darkSwitch.focus();
      }
    }
  }

  // =======================================
  // Message Box handling 
  // =======================================
  if (msgBoxes) {
    if ( msgBoxes.length === 1 ) {
      msgBoxes[0].onclick = (evt) => {
        closePopup(msgBoxes[0]);
      }
    }
    else {
      msgBoxes.forEach((el) => {
        el.onclick = (evt) => {
          closePopup(el);
        }
      });
    }
  }

  // ===============
  // Members Scripts
  // ===============
  // Give the parameter a variable name
  const action = getParameterByName('action');
  const stripe = getParameterByName('stripe');

  switch (action) {
    case 'subscribe':
      // addClass('body', 'subscribe-success');
        document.body.classList.add('subscribe-success')
      break;
    case 'signup': 
      // window.location = '/signup/?action=checkout';
      break;
    case 'checkout':
      // addClass('body', 'signup-success');
      // addClass('form[data-members-form]', 'success');
      document.body.classList.add('signup-success');
      break;
    case 'signin':
      // addClass('body', 'signin-success');
      // addClass('form[data-members-form]', 'success');
      document.body.classList.add('signin-success');
      break;
    default:
      break;
  }

  if (stripe == 'success') {
    // addClass('body', 'checkout-success');
    document.body.classList.add('checkout-success');
  }

  // Reset form on opening subscrion overlay
  if (subscribeButton) {
    subscribeButton.onclick = function(event){
      document.querySelector('.subscribe-overlay form').className = '';
      document.querySelector('.subscribe-email').value = '';
    };
  }

  // =======================================
  // Disable load more posts button 
  // =======================================
  if (loadMoreBtn && global.max_pages === 1) {
    loadMoreBtn.disabled = true;
    loadMoreBtn.classList.add('btn--disabled');
  }

  // ===============
  // Load More Posts
  // ===============
  if (loadMoreBtn) {
    loadMoreBtn.onclick = () => {
      loadMorePosts(loadMoreBtn);
    }
  }

  // ======================
  // Post Table of Contents
  // ======================
  if (postToc) {
    const tocToggle = document.querySelector('.js-toc-toggle');

    if (tocToggle) {
      tocToggle.onclick = (evt) => {
        toggleClass('.js-toc', 'is-active');
        toggleClass('.js-toc-icon', 'is-rotated');
      }
    }

    tocbot.init({
      // Where to render the table of contents.
      tocSelector: '.js-toc',
      // Where to grab the headings to build the table of contents.
      contentSelector: '.js-toc-content',
      // Which headings to grab inside of the contentSelector element.
      headingSelector: 'h1, h2, h3',
      // For headings inside relative or absolute positioned containers within content.
      hasInnerContainers: true,
      // smooth scroll
      scrollSmooth: false,
      // offset
      headingsOffset: 60,
    });

    const tocLinks = document.querySelectorAll('.toc-list-item a[href^="#"]');
    if (tocLinks) {
      tocLinks.forEach(link => {
        link.onclick = function(e) {
          removeClass('.js-toc', 'is-active');
        }
      })
    }
  }

  // =============
  // Image Gallery
  // =============
  images.forEach(function (image) {
    if (config.enable_image_lightbox) {
      var wrapper = document.createElement('a');
      wrapper.setAttribute('data-no-swup', '');
      wrapper.setAttribute('data-fslightbox', '');
      wrapper.setAttribute('href', image.src);
      wrapper.setAttribute('aria-label', 'Click for Lightbox');
      image.parentNode.insertBefore(wrapper, image.parentNode.firstChild);
      wrapper.appendChild(image);
    }
    // image.setAttribute('class', 'lazyload lazy');
    // image.setAttribute('data-src', image.src);
    // image.removeAttribute('src');
    // updateLazyLoad(lazyLoad);
  });

  galleryImages.forEach(function (image) {
    image.setAttribute('alt', 'Gallery Image');
    var container = image.closest('.kg-gallery-image');
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = ratio + ' 1 0%';
  })
  
  // =============
  // Lightbox
  // =============
  refreshFsLightbox();

  // ==================
  // Social Share Logic
  // ==================
  if (socialShare.length > 0) {
    jsShareable(socialShare);
  }

  // ==================
  // Post external links
  // ==================
  if (config.open_links_in_new_tab) {
    const domain = location.host.replace('www.', '');
    const postLinks = document.querySelectorAll('.post__content a');
  
    postLinks.forEach((link) => {
      const linkURL = link.href.includes('?ref=') ? link.href.split('?ref=')[0] : link.href
      if(!linkURL.includes(domain)) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noreferrer noopener');
      }
    })
  }
};

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener("DOMContentLoaded", callback);
}

// ===============================
// Dark/Light mode theme handling
// ===============================
const setTheme = (sTheme) => {
  document.documentElement.setAttribute('data-color-scheme', sTheme);
  localStorage.setItem('USER_COLOR_SCHEME', sTheme);
}

// ===============================
// Class modifying helepers
// ===============================
const toggleClass = (el, cls) => {
  document.querySelector(el).classList.toggle(cls);
}

const addClass = (el, cls) => {
  document.querySelector(el).classList.add(cls);
}

const removeClass = (el, cls) => {
  document.querySelector(el).classList.remove(cls);
}

// ===============================
// Scroll to function
// ===============================
const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

// ===============================
// Check if element is in viewport
// ===============================
function isInViewport(el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  let width = el.offsetWidth;
  let height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return(
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
}

// =================
// Lazyload function
// =================
function newLazyLoad() {
  return new LazyLoad({
    elements_selector: ".lazyload",
    class_loading: "loading",
    class_loaded: "loaded",
    treshold: 100,
    // use_native: true,
    callback_enter: function(el) {
      el.classList.add('loading');
    },
    callback_set: function(el) {
      el.classList.remove('loading');
      el.classList.add('loaded');
    }
  });
}

function updateLazyLoad(lazyLoad) {
  lazyLoad.update();
}

// ===============================
// Title highlight marker function
// ===============================
function prepareTitleHighlights(titles) {
  titles.forEach((title) => {
    const titleTarget = title.querySelector('a') || title;
    const originalTitle = title.dataset.titleOriginal ||
      titleTarget.textContent.trim().replace(/\s+/g, ' ');
    const parsedTitle = parseTitleMarkers(originalTitle);
    const spotlightCard = title.closest('.post-card--special');
    const isSpotlightTitle = Boolean(spotlightCard);
    const spotlightMeta = spotlightCard ? parseSpotlightMeta(spotlightCard.getAttribute('data-spotlight-meta')) : {};
    const displayTitle = isSpotlightTitle && spotlightMeta.spotlight
      ? parseTitleHighlightMarkers(spotlightMeta.spotlight)
      : isSpotlightTitle
        ? parsedTitle.spotlight
        : parsedTitle.main;

    title.dataset.titleOriginal = originalTitle;
    title.dataset.fitTitle = displayTitle.text;
    title.dataset.highlightRanges = JSON.stringify(isSpotlightTitle ? displayTitle.ranges : []);

    if (titleTarget.hasAttribute('aria-label')) {
      titleTarget.setAttribute('aria-label', displayTitle.text);
    }

    if (isSpotlightTitle) {
      renderHighlightedText(titleTarget, displayTitle.text, displayTitle.ranges);
      title.classList.add('is-title-ready');
      return;
    }

    titleTarget.textContent = displayTitle.text;
    title.classList.add('is-title-ready');
  });
}

function cleanSpotlightTickers(tickers) {
  tickers.forEach((ticker) => {
    const spotlightCard = ticker.closest('.post-card--special');
    const spotlightMeta = spotlightCard ? parseSpotlightMeta(spotlightCard.getAttribute('data-spotlight-meta')) : {};
    const tickerItems = ticker.querySelectorAll('.post-card__ticker-track span');
    const source = ticker.getAttribute('aria-label') ||
      (tickerItems[0] ? tickerItems[0].textContent : '');
    const parsedTitle = parseTitleMarkers(source);
    const tickerText = spotlightMeta.banner || parsedTitle.main.text;

    ticker.setAttribute('aria-label', tickerText);
    tickerItems.forEach((item) => {
      item.textContent = tickerText;
    });
  });
}

function parseSpotlightMeta(rawMeta) {
  const meta = {
    banner: '',
    spotlight: ''
  };

  if (!rawMeta) {
    return meta;
  }

  const normalizedMeta = rawMeta
    .replace(/\r/g, '\n')
    .replace(/\s+/g, ' ')
    .trim();

  const bannerMatch = normalizedMeta.match(/(?:^|\s)1\s*:\s*([\s\S]*?)(?=(?:\s)2\s*:|$)/);
  const spotlightMatch = normalizedMeta.match(/(?:^|\s)2\s*:\s*([\s\S]*?)$/);

  if (bannerMatch) {
    meta.banner = bannerMatch[1].trim().replace(/\s+/g, ' ');
  }

  if (spotlightMatch) {
    meta.spotlight = spotlightMatch[1].trim().replace(/\s+/g, ' ');
  }

  return meta;
}

function parseTitleMarkers(title) {
  const normalizedTitle = title.trim().replace(/\s+/g, ' ');
  const spotlightMatch = normalizedTitle.match(/\s*\[\[([\s\S]*?)\]\]\s*$/);
  let mainTitle = normalizedTitle;
  let spotlightTitle = normalizedTitle;

  if (spotlightMatch) {
    mainTitle = normalizedTitle.slice(0, spotlightMatch.index).trim().replace(/\s+/g, ' ');
    spotlightTitle = spotlightMatch[1].trim().replace(/\s+/g, ' ');
  }

  return {
    main: parseTitleHighlightMarkers(mainTitle),
    spotlight: parseTitleHighlightMarkers(spotlightTitle)
  };
}

function parseTitleHighlightMarkers(title) {
  const normalizedTitle = title.trim().replace(/\s+/g, ' ');
  const ranges = [];
  let text = '';
  let index = 0;
  const markerPattern = /\[([^\[\]]+)\]/g;
  let match;

  while ((match = markerPattern.exec(normalizedTitle)) !== null) {
    text += normalizedTitle.slice(index, match.index);
    const start = text.length;
    text += match[1];
    ranges.push({ start, end: text.length });
    index = match.index + match[0].length;
  }

  text += normalizedTitle.slice(index);

  return {
    text,
    ranges
  };
}

function renderHighlightedText(parent, text, ranges) {
  parent.textContent = '';
  appendHighlightedText(parent, text, 0, ranges);
}

function appendHighlightedText(parent, text, offset, ranges) {
  const end = offset + text.length;
  let cursor = offset;

  ranges.forEach((range) => {
    if (range.end <= offset || range.start >= end) {
      return;
    }

    const start = Math.max(range.start, offset);
    const stop = Math.min(range.end, end);

    if (start > cursor) {
      parent.appendChild(document.createTextNode(text.slice(cursor - offset, start - offset)));
    }

    const span = document.createElement('span');
    span.className = 'title-highlight';
    span.textContent = text.slice(start - offset, stop - offset);
    parent.appendChild(span);
    cursor = stop;
  });

  if (cursor < end) {
    parent.appendChild(document.createTextNode(text.slice(cursor - offset)));
  }
}

// ============================
// Spotlight title fit function
// ============================
function scheduleSpotlightTitleFit(titles) {
  fitSpotlightTitles(titles);

  requestAnimationFrame(() => {
    fitSpotlightTitles(titles);
  });

  setTimeout(() => {
    fitSpotlightTitles(titles);
  }, 120);
}

function fitSpotlightTitles(titles) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  titles.forEach((title) => {
    const content = title.closest('.post-card__content');
    const titleLink = title.querySelector('a') || title;

    if (!content || !context) {
      return;
    }

    const originalText = title.dataset.fitTitle || titleLink.textContent.trim().replace(/\s+/g, ' ');
    const highlightRanges = title.dataset.highlightRanges
      ? JSON.parse(title.dataset.highlightRanges)
      : [];
    title.dataset.fitTitle = originalText;

    const contentStyle = window.getComputedStyle(content);
    const contentWidth = content.clientWidth -
      parseFloat(contentStyle.paddingLeft) -
      parseFloat(contentStyle.paddingRight);

    if (contentWidth <= 0) {
      return;
    }

    const fitWidth = Math.max(0, contentWidth * 0.97);

    const titleStyle = window.getComputedStyle(title);
    const words = originalText.split(' ').filter(Boolean);
    const lines = getBestSpotlightTitleLines(words, titleStyle, context);

    title.style.width = contentWidth + 'px';
    title.classList.add('is-fitted');
    title.classList.toggle('is-fitted-multi', lines.length > 1);
    title.classList.toggle('is-fitted-single', lines.length === 1);
    renderSpotlightTitleLines(titleLink, originalText, lines, highlightRanges);
    fitSpotlightTitleSize(title, fitWidth, titleStyle, context, lines);
  });
}

function renderSpotlightTitleLines(titleLink, originalText, lines, highlightRanges) {
  titleLink.textContent = '';

  let lineSearchIndex = 0;

  lines.forEach((line) => {
    const span = document.createElement('span');
    span.className = 'post-card__title-line';
    const lineStart = originalText.indexOf(line, lineSearchIndex);
    const safeLineStart = lineStart >= 0 ? lineStart : lineSearchIndex;
    appendHighlightedText(span, line, safeLineStart, highlightRanges);
    lineSearchIndex = safeLineStart + line.length;
    titleLink.appendChild(span);
  });
}

function fitSpotlightTitleSize(title, fitWidth, titleStyle, context, lines) {
  const lineMaxWidth = getMaxMeasuredLineWidth(lines, titleStyle, context);
  const minSize = Math.max(22, Math.min(38, fitWidth * 0.075));
  const maxSize = Math.min(280, fitWidth * 0.21);
  const estimatedSize = lineMaxWidth > 0
    ? Math.max(minSize, Math.min(maxSize, (fitWidth / lineMaxWidth) * 100 * 0.985))
    : minSize;
  let low = minSize;
  let high = Math.max(minSize, estimatedSize);

  title.style.fontSize = high + 'px';

  if (spotlightTitleFits(title, fitWidth)) {
    while (high < maxSize) {
      const next = Math.min(maxSize, high * 1.08);
      title.style.fontSize = next + 'px';

      if (!spotlightTitleFits(title, fitWidth)) {
        break;
      }

      low = next;
      high = next;

      if (next === maxSize) {
        break;
      }
    }
  } else {
    high = estimatedSize;
  }

  for (let i = 0; i < 14; i++) {
    const mid = (low + high) / 2;
    title.style.fontSize = mid + 'px';

    if (spotlightTitleFits(title, fitWidth)) {
      low = mid;
    } else {
      high = mid;
    }
  }

  title.style.fontSize = low + 'px';
}

function spotlightTitleFits(title, fitWidth) {
  const lines = title.querySelectorAll('.post-card__title-line');

  return Array.from(lines).every((line) => {
    return line.getBoundingClientRect().width <= fitWidth + 1;
  });
}

function getBestSpotlightTitleLines(words, titleStyle, context) {
  if (words.length <= 3) {
    return [words.join(' ')];
  }

  let bestLines = [words.join(' ')];
  let bestScore = Infinity;

  for (let i = 1; i < words.length; i++) {
    const lines = [
      words.slice(0, i).join(' '),
      words.slice(i).join(' ')
    ];
    const lineWidths = lines.map((line) => measureSpotlightLine(line, titleStyle, context));
    const longest = Math.max.apply(null, lineWidths);
    const imbalance = Math.abs(lineWidths[0] - lineWidths[1]);
    const score = longest + (imbalance * 0.2);

    if (score < bestScore) {
      bestScore = score;
      bestLines = lines;
    }
  }

  return bestLines;
}

function getMaxMeasuredLineWidth(lines, titleStyle, context) {
  return Math.max.apply(null, lines.map((line) => {
    return measureSpotlightLine(line, titleStyle, context);
  }));
}

function measureSpotlightLine(line, titleStyle, context) {
  context.font = [
    titleStyle.fontStyle,
    titleStyle.fontWeight,
    '100px',
    titleStyle.fontFamily
  ].join(' ');

  return context.measureText(line).width;
}

function debounce(fn, wait) {
  let timeout;

  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}

// =================
// Close popup
// =================
const closePopup = (el) => {
  el.parentNode.parentNode.classList.add('is-closed');
  setTimeout(function(){
    el.parentNode.parentNode.style.display = "none";
  }, 1000); 
}

// =================
// Copy to clipboard
// =================
const copyToClipboard = (src, str) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  src.classList.add('has-tooltip');
  src.setAttribute('data-label', 'Copied!');

  src.onmouseleave = () => { 
    src.classList.remove('has-tooltip');
    setTimeout(function(){
      src.setAttribute('data-label', '');
    }, 500); 
  }
};

// ==============
// Social Sharing
// ==============
function jsShareable(socialShare) {
  if (socialShare.length > 1) {
    socialShare.forEach((el) => {
      let title = el.getAttribute('data-title');
      let url = el.getAttribute('data-url');
      let type = el.getAttribute('data-type');
      
      jsShare(el, title, url, type);
    });
  } else {
    let title = socialShare.getAttribute('data-title');
    let url = socialShare.getAttribute('data-url');
    let type = socialShare.getAttribute('data-type');

    jsShare(socialShare, title, url, type);
  }
}

function jsShare (el, title, url, type) {
  let shareLink;

  switch(type) {
    case 'twitter':
      shareLink = 'https://twitter.com/share?text=' + title + '&amp;url=' + url;
      break;
    case 'facebook':
      shareLink = 'https://www.facebook.com/sharer/sharer.php?u='+ url;
      break;
    case 'linkedin':
      shareLink = 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + '&summary=' + title;
      break;
    case 'email':
      el.onclick = () => {
        location.href = el.getAttribute('href');
      }
      el.onkeydown = (evt) => {
        if (evt.key === 'Enter') {
          location.href = el.getAttribute('href');
        }
      }
      break;
    case 'copy': 
      el.onclick = () => {
        copyToClipboard(el, location.href);
      }
      el.onkeydown = (evt) => {
        if (evt.key === 'Enter') {
          copyToClipboard(el, location.href);
        }
      }
      break;
    default:
      break;
  }

  if (shareLink) {
    el.onclick = () => {
      socialWindow(shareLink);
    }

    el.onkeydown = (evt) => {
      if (evt.key === 'Enter') {
        socialWindow(shareLink);
      }
    }
  }
}

const socialWindow = (url) => {
  var left = (screen.width - 580) / 2;
  var top = (screen.height - 580) / 2;
  var params = "menubar=no,toolbar=no,status=no,width=580,height=296,top=" + top + ",left=" + left;
  window.open(url,"NewWindow",params);
}; 

// if last page disable button
if (global.pagination_current_page === global.pagination_max_pages) {
  const loadMore = document.querySelector('#load-more-posts')
  loadMore.disabled = true;
  loadMore.classList.add('btn--disabled');
}

// ===============
// Load More Posts
// ===============
const loadMorePosts = (button) => {
  
  // Next link
  const nextPage = document.querySelector('link[rel=next]');

  global.pagination_next_page_link = nextPage && !global.pagination_next_page_link
                        ? nextPage.getAttribute('href') 
                        : global.pagination_next_page_link;

  // Update current page value
  if (nextPage && global.pagination_next_page <= global.pagination_max_pages) {
    const fetchLink = global.pagination_next_page_link

    // Fetch next page content
    fetch(fetchLink).then(function (response) {
      // Fetch Successfull
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      
      // Get posts
      const posts = doc.querySelectorAll('.post-wrap');
      const postContainer  = document.querySelector('.posts');
      const nextPage = doc.querySelector('link[rel=next]');
      
      // Add each post to the page
      posts.forEach(post => {
        postContainer.appendChild(post);
      })
      
      // Update lazyload for images
      updateLazyLoad(lazyLoad);

      // Disable button on last page
      if (global.pagination_next_page === global.pagination_max_pages) {
        button.disabled = true;
        button.classList.add('btn--disabled');
      }

      // Update next page number
      global.pagination_next_page_link = nextPage ? nextPage.getAttribute('href') : '';
      global.pagination_next_page = global.pagination_next_page_link ? global.pagination_next_page + 1 : NaN;

    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  } 
  else {
    // No more pages, disable button
    button.disabled = true;
    button.classList.add('btn--disabled');
  }
}


// ================================
// Members Parse the URL parameter
// ================================
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
